import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import detector from "i18next-browser-languagedetector";
import Backend from 'i18next-xhr-backend'

i18n
    .use(Backend)
    .use(detector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        whitelist: ['en', 'de', 'nl'],
        ns: ['login', 'result', 'translation', 'utils', 'user'],
        interpolation: {
            escapeValue: false
        },
        backend: {
            loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
        },
        react: {
            useSuspense: false
        }//,
        // debug: process.env?.NODE_ENV === 'development',
    })

export default i18n